import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';

export const MenuItemsButton = ({ data = [] }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size="small"
      >
        ver
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {/* <MenuItem onClick={handleClose}>product</MenuItem> */}
        {data.length > 0 ? (
          data.map(({ paqueteria, tracking }, i) => (
            <MenuItem key={i} onClick={handleClose}>
              {`N° Tracking: ${tracking} - Paquetería (${paqueteria})`}
            </MenuItem>
          ))
        ) : (
          <MenuItem onClick={handleClose}>product</MenuItem>
        )}
      </Menu>
    </>
  );
};
